import React from "react";
import { useHistory, useRouteMatch } from "react-router-dom";

// PROFILE PAGE COMPONENTS
import ProfileMenuButton from "../profile-menu-button/ProfileMenuButton.component";
// IMAGES
// import profileIcon from "assets/images/profile/profile-icon.svg";
import settingsIcon from "assets/images/profile/settings-icon.svg";
import unlockIcon from "assets/images/profile/unlock-icon.svg";

const ProfileMenuItems = () => {
  const { url } = useRouteMatch();
  const history = useHistory();

  const menuItems = [
    // {
    //   id: 0,
    //   icon: profileIcon,
    //   text: "Personal Information",
    //   onClick: () => history.push(`${url}/personal-information`),
    // },
    {
      id: 1,
      icon: settingsIcon,
      text: "Settings",
      onClick: () => history.push(`${url}/settings`),
    },
    {
      id: 2,
      icon: unlockIcon,
      text: "Change Password",
      onClick: () => history.push(`${url}/change-password`),
    },
  ];

  return (
    <div className="profile-menu-items">
      {menuItems.map((item) => {
        return (
          <ProfileMenuButton
            icon={item.icon}
            text={item.text}
            onClick={item?.onClick}
            key={item.id}
          />
        );
      })}
    </div>
  );
};

export default ProfileMenuItems;
